var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene"},[_c('div',{staticClass:"cube"},[_c('div',{staticClass:"front"}),_c('div',{staticClass:"back"}),_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"}),_c('div',{staticClass:"top"}),_c('div',{staticClass:"bottom"})])])
}]

export { render, staticRenderFns }